module.exports = "/_next/static/images/CompleteDataCollected@2x-f3db6dc3c06004bb5da7d9509d872eb0.png";